<script lang="ts">
  import { useConsoleArt } from "$lib/core/ConsoleArt.svelte.ts";
  import { useScrollHashIntoView } from "$lib/core/HashNavigation";
  import Footer from "$lib/design-systems/product/patterns/Footer.svelte";
  import StickyHeader from "$routes/(docs)/docs/_components/StickyHeader.svelte";
  import DocsNavbar from "./_components/docs-navbar/DocsNavbar.svelte";

  useConsoleArt();

  useScrollHashIntoView();
</script>

<div class="docs-shell flex min-h-screen flex-col">
  <StickyHeader>
    <DocsNavbar />
  </StickyHeader>
  <slot />
  <Footer />
</div>

<style>
  /* Docs headings and accents follow the marketing redesign: ABC Diatype in
     place of Goga, and the v2 neutral in place of the legacy light green. */
  .docs-shell {
    --font-goga: var(--font-v2-sans);
    /* Goga's ss01 is its single-story a; in Diatype ss01 restores the two-story one. */
    --font-goga-features: normal;
    --color-light-green: var(--color-v2-primary-neutral-100);
  }
</style>
